$(function() {

    //成功の場合は自動で消える
    setTimeout(function() {
        $('.auto-close').parent().parent().fadeOut();
    }, 3000);

    //スクロールアップ
    var pagetop = $('#pagetop');
    // ボタン非表示
    pagetop.hide();
    // 100px スクロールしたらボタン表示
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 100) {
            pagetop.fadeIn();
        } else {
            pagetop.fadeOut();
        }
    });
    pagetop.on('click', function () {
        $('body, html').animate({ scrollTop: 0 }, 500);
        return false;
    });

});
